import { Stack } from "PFComponents/containers";
import { ParentChildCommonProps } from "PFComponents/experience_level/experience_level.types";
import { ProfileExperienceTooltipContent } from "PFComponents/experience_level/parts/experience_level_tooltip_content/parts/profile_experience_tooltip_content";
import { Experience } from "PFCore/types";
import { useTranslation } from "react-i18next";

import { InlineIconText } from "./inline_icon_text";

type ProfileColumnTooltipContentProps = {
  experience?: Experience | null;
  experienceLevels: Experience[];
  experienceLabelMap: Record<Experience, string>;
  isCore?: boolean;
  isDevelopmental?: boolean;
} & ParentChildCommonProps;

export const ProfileColumnTooltipContent = ({
  experienceLevels,
  experienceLabelMap,
  experience,
  hasParentValues,
  hasChildValues,
  isCore,
  isDevelopmental
}: ProfileColumnTooltipContentProps) => {
  const { t } = useTranslation("core", { keyPrefix: "customValue" });

  return (
    <Stack>
      <ProfileExperienceTooltipContent
        experienceLevels={experienceLevels}
        experienceLabelMap={experienceLabelMap}
        experience={experience}
        hasParentValues={hasParentValues}
        hasChildValues={hasChildValues}
      />
      {isCore && <InlineIconText iconName="core" text={t("core")} />}
      {isDevelopmental && <InlineIconText iconName="development" text={t("developmental")} />}
    </Stack>
  );
};
